// extracted by mini-css-extract-plugin
export var container = "_ca-0";
export var icon = "_ca-1";
export var text = "_ca-2";